import PositionsSelect from './PositionsSelect';

export default PositionsSelect;
